import React from 'react';

function TestimonialCards() {
  const testimonials = [
    {
      id: 1,
      name: "Alexandra Kim",
      role: "CEO, TechStart Inc.",
      content: "Their innovative approach and attention to detail transformed our business. The results exceeded all our expectations and the team was incredible to work with.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1581065178047-8ee15951ede6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NDkwNDAxMjN8MA&ixlib=rb-4.1.0&q=80&w=1080",
      attribution: { name: "Annika Palmari", url: "https://unsplash.com/@palmariannika?utm_source=makerdevi&utm_medium=referral" }
    },
    {
      id: 2,
      name: "Michael Thompson",
      role: "Founder, Digital Solutions",
      content: "Professional, reliable, and results-driven. They delivered exactly what they promised and helped us scale our operations efficiently.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHw1fHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NDkwNDAxMjN8MA&ixlib=rb-4.1.0&q=80&w=1080",
      attribution: { name: "Jurica Koletić", url: "https://unsplash.com/@juricakoletic?utm_source=makerdevi&utm_medium=referral" }
    },
    {
      id: 3,
      name: "Rachel Martinez",
      role: "Director of Marketing, GrowthCo",
      content: "Outstanding service and exceptional quality. Their team understands our vision and consistently delivers solutions that drive real business value.",
      rating: 5,
      image: "https://images.unsplash.com/photo-1551836022-deb4988cc6c0?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHw2fHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NDkwNDAxMjN8MA&ixlib=rb-4.1.0&q=80&w=1080",
      attribution: { name: "Amy Hirschi", url: "https://unsplash.com/@amyhirschi?utm_source=makerdevi&utm_medium=referral" }
    }
  ];

  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <span key={i} className={`text-xl ${i < rating ? 'text-yellow-400' : 'text-gray-300'}`}>
        ★
      </span>
    ));
  };

  return (
    <div className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">What Our Clients Say</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it - hear from the businesses we've helped transform
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300">
              {/* Rating Stars */}
              <div className="flex mb-6">
                {renderStars(testimonial.rating)}
              </div>
              
              {/* Quote */}
              <blockquote className="text-gray-700 mb-6 italic">
                "{testimonial.content}"
              </blockquote>
              
              {/* Author */}
              <div className="flex items-center">
                <div className="relative">
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover"
                  />
                  
                  {/* Image Attribution */}
                  <span className="group/attribution absolute bottom-0 right-0 text-[8px] text-white outline outline-1 outline-white px-[4px] rounded-lg z-10 min-w-3 max-w-[calc(100%-8px)] h-3 leading-3 truncate text-center shadow">
                    <span className="block drop-shadow-md group-hover/attribution:hidden">i</span>
                    <span className="hidden drop-shadow-md group-hover/attribution:block">
                      Image on{' '}
                      <a
                        href="https://unsplash.com?utm_source=Maker%20AI&utm_medium=referral"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#fff', textDecoration: 'none' }}
                      >
                        Unsplash
                      </a>{' '}
                      by{' '}
                      <a
                        href={testimonial.attribution.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#fff', textDecoration: 'none' }}
                      >
                        {testimonial.attribution.name}
                      </a>
                    </span>
                  </span>
                </div>
                
                <div className="ml-4">
                  <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                  <p className="text-gray-600 text-sm">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TestimonialCards;